import React from "react";
import {
  Container,
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  DatePicker,
  FormSelect,
  FormInput,
  Button,
  Form,
} from "shards-react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { FiSearch } from "react-icons/fi";
// import Select from "react-select";
import moment from "moment";
import {actions as AppActions} from "../../_stores/app.store";
import Modal from "react-bootstrap/Modal";
import BatchReportService from "../../services/batchReport.service";
import SupplierService from "../../services/supplier.service";
import ProcessLogService from "../../services/processLog.service";
import ProcessFileService from "../../services/processFile.service";
import FileUploadErrorLogs from "./FileUploadErrorLogs";
import { TiDeleteOutline } from "react-icons/ti";
  import TableRow from '../layout/TableRow';
import TableColumnRow from '../layout/TableColumnRow';
import { FcPlus, FcAlphabeticalSortingAz, FcAlphabeticalSortingZa } from "react-icons/fc";
import refresh from "../../images/refresh.png";
import ScaleLoader from "react-spinners/ScaleLoader";
import projectService from "../../services/project.service";
import ReportService from "../../services/report.service";
import ConversionDataService from "../../services/conversions.service";
import * as XLSX from "xlsx";
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";

import FileUploadLogService from "../../services/fileUploadLog.service";

import TempFileUploadService from "../../services/tempFileUpload.service";
//import logger from 'logging-library';
//import { CustomErrorComponent } from 'custom-error';

import { validateMultipleFileSize } from '../util/validate';

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

let processFileByIdQueueArray = [];

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

const date = new Date();
const currentyear = date.getUTCFullYear();
let YEAR = [];
YEAR.push(currentyear-2);
YEAR.push(currentyear-1);
YEAR.push(currentyear);
YEAR.push(currentyear+1);

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
};

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const FILE_TYPE =[
  "Customer",
  "Product",
  "Sales",
  "Return",
]

const Columns = [
  {
    title: "Batch ID",
    value: "_id",
  },
  // {
  //   title: "Download Time",
  //   value: "downloadTimeStamp",
  // },
  {
    title: "File Name",
    value: "fileName",
  },
  {
    title: "File Metadata",
    value: "fileMetadata",
  },
  {
    title: "File Type",
    value: "fileType",
  },
  {
    title: "Step",
    value: "step",
  },
  {
    title: "Supplier Code",
    value: "supplierCode",
  },
  // {
  //   title: "Time Log",
  //   value: "Batch Id",
  // },
  // {
  //   title: "Updated At",
  //   value: "updatedAt",
  // },
  {
    title: "Year - Month",
    value: "yearmonth",
  }
];

const currentDate = new Date();
const currentMonth = MONTHS[currentDate.getMonth() - 1]; // Note: getMonth() returns month from 0 to 11
const currentYear = currentDate.getFullYear();

console.log(`Current month: ${currentMonth}`);
console.log(`Current year: ${currentYear}`);

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBatch: {},
      batchLogs: [],
      supplierList: [],
      selectedSupplier: "",
      yearList: YEAR,
      monthList: MONTHS,
      selectedMonth: currentMonth,
      selectedYear: currentYear,
      fileType:"",
      file: null,
      isLastFile: false,
      supplier: null,
      fileTypeList: FILE_TYPE,
      selectedFileType: "Sales",
    };

    this.onFileChanged = this.onFileChanged.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleSelectedSupplierChange = this.handleSelectedSupplierChange.bind(this);
    this.handleSelectedYearChange = this.handleSelectedYearChange.bind(this);
    this.handleSelectedMonthChange = this.handleSelectedMonthChange.bind(this);
  }

  componentDidMount() {
    this.fetchSuppliers();
  }

  componentDidUpdate(prevProps) {}

  fetchSuppliers() {
    AppActions.setLoading(true);
    SupplierService.getAll().then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length) {
        const supplierArray = response.data.data;
        supplierArray.sort((a, b) => a.supplierCode.localeCompare(b.supplierCode));
        
        this.setState({
          supplierList: supplierArray,
        });
      }


        
    });
  }

  async handleSelectedSupplierChange(evt) {
    //console.log('handleSelectedSupplierChange', evt.target.value);
    
    
    if(SAUDI || EGYPT) {
      console.log(`handleChange Option selected:`, evt.target.value);
      const supplier = this.state.supplierList.find(supplier => supplier.supplierCode === evt.target.value);
      this.setState({
        selectedSupplier: evt.target.value === "0" ? "" : evt.target.value,
        supplier: supplier,
      })
    } else if(SPAIN) {
      const supplier = this.state.supplierList.find(supplier => supplier.supplierCode === evt.target.value);
      //console.log('handleSelectedSupplierChange.supplier',supplier);
  
      this.setState({ selectedSupplier: evt.target.value, supplier: supplier });
        var data = {
          projectId: this.props.projectId,
          supplierCode: evt.target.value,
          year: this.state.selectedYear,
          month: this.state.selectedMonth,
          //file: file,
      }
      const fileUploadLogs = await this.getFileUploadLog(data);
    }
  }

  async handleSelectedYearChange(evt) {

    this.setState({ selectedYear: evt.target.value });

    var data = {
      projectId: this.props.projectId,
      supplierCode: this.state.selectedSupplier,
      year: evt.target.value,
      month: this.state.selectedMonth,
      //file: file,
    }
    const fileUploadLogs = await this.getFileUploadLog(data);
  }


  async handleSelectedMonthChange(evt) {

    this.setState({ selectedMonth: evt.target.value });

    var data = {
      projectId: this.props.projectId,
      supplierCode: this.state.selectedSupplier,
      year: this.state.selectedYear,
      month: evt.target.value,
      //file: file,
    }
    const fileUploadLogs = await this.getFileUploadLog(data);
  }


  onFileChanged(evt) {
    AppActions.setLoading(true);
    const { target } = evt;
    let file = null;

    if (target.files && target.files.length) {
      file = target.files[0];
      this.setState({ file : file });
    }
  }

  handleFileUpload() {
    console.log('handleFileUpload.excelRows');
    const { file } = this.state;
    var data = {
      projectId: this.props.projectId,
      supplierCode: this.state.selectedSupplier,
      filetype: this.state.selectedFileType,
      year: this.state.selectedYear,
      month: this.state.selectedMonth,
      file: file,
    }
    console.log('handleFileUpload.data', data);
    if ((SAUDI || EGYPT) && this.isValidExtension(file) === false) {
      var notify_message = ({
        type: "error",
        message: "Invalid file format. Please upload .txt, .xls, .xlsx, .dat or .csv file."
      });
      this.notify(notify_message.type, notify_message.message);
      return;
    }

    AppActions.setLoading(true);
    TempFileUploadService.create(data, true)
      .then(async(response) => {
        AppActions.setLoading(false);

        console.log('handleFileUpload.response', response);
        if(response.data.success){ // check for success
          const fileUploadLogs = await this.getFileUploadLog(response.data.data);
          var notify_message =({
            type:"success",
            message:"File has been uploaded successfully."
          });
          //this.setState({ file : null,  selectedSupplier: "", selectedYear: currentYear, selectedMonth: currentMonth });
          this.setState({ file: null, selectedSupplier: "", selectedYear: currentYear, selectedMonth: currentMonth, selectedFileType: "Sales" });
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:"File has been Already uploaded"
            });
          }
          this.notify(notify_message.type,notify_message.message);
        }
      
    });

  }

  getFileUploadLog(data) {
    console.log('getFileUploadLog', data);

    var reqdata = {
      projectId: data.projectId,
      supplierCode: data.supplierCode,
      year: data.year,
      month: data.month,
      //fileName: data.file,
    }
    AppActions.setLoading(true);
    //console.log('getFileUploadLog.reqdata', reqdata);
    FileUploadLogService.create(data)
      .then(async(response) => {
        AppActions.setLoading(false);

       // console.log('getFileUploadLog.response', response);
        this.setState({ batchLogs: response.data.data });

        
      
    });
  }

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}


  handleChange(selectedOption) {
    console.log(`handleChange Option selected:`, selectedOption);
    this.setState({ selectedSupplier: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedSupplier)
    );
  };

  getFileExtension(name) {
    const parts = name.split('.');

    if (parts.length > 0) {
        return parts.pop();
    }

    return false;
  }

  isValidExtension(file) {
    //console.log('isValidExtension'  + name );
    let result = false;
    for (let i = 0; i < file.length; i++) {
      const name = file[i].name;
      let extension = this.getFileExtension(name);
      extension = extension && extension.toLowerCase() || '';
      const {fileType} = this.state;
      console.log('extension', extension);
      if(SAUDI || EGYPT){
        if (extension.toLowerCase() === 'txt') {
          result = true;
        } else if (extension.toLowerCase() === 'xls' || extension.toLowerCase() === 'xlsx') {
          result = true;
        } else if (extension === 'csv') {
          result = true;
        } else if (extension === 'dat') {
          result = true;
        }
      } else {
        if(fileType === "textFile" || fileType === "TEXT File") {
          result = extension === 'txt';
        } else if(fileType === "excelFile" || fileType === "EXCEL File") {
          result = (extension === 'xls' || extension === 'xlsx');
        } else if(fileType === "csvFile") {
          result = extension === 'csv';
        }
      }
    }

    return result;
  }

  readFile(e) {
    const { target } = e;
    let file = null;
    if(SAUDI || EGYPT){
      if (target.files && target.files.length > 0) {
        //file = target.files[0];
        file = target.files;
        const isValid = validateMultipleFileSize(file);
        if (!isValid) return;

        this.setState({ file: file });
      }
    } else if(SPAIN){
      if (target.files && target.files.length > 0) {
        //console.log('readFile.target.files', target.files);
          //file = target.files[0];
          file = target.files;
          this.setState({ file : file });
      }
    }
    
  }

  render() {
    const {
      selectedBatch,
      batchLogs,
      supplierList,
      selectedSupplier,
      monthList,
      yearList,
      selectedMonth,
      selectedYear,
      selectedFileType,
      fileTypeList,
    } = this.state;

    return (
      <>
        <Row className="mb-4">
          <Col md="12" className="mt-3">
              <h6 className="m-0">Raw File Upload</h6>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md="12" className="">
            <Row>
              <Col md="3" className="flx-dir-col">
                <label className="mb-0">Select {SPAIN ? 'Hospital' : 'Supplier'}</label>
                <FormSelect
                  id="supplier-select"
                  onChange={this.handleSelectedSupplierChange}
                  // onChange={(evt) => 
                  //     this.setState({
                  //       selectedSupplier: evt.target.value,
                  //     })
                  // }
                  value={selectedSupplier}
                >
                  <option value={0}>Select</option>
                  {supplierList.map((supplier) => (
                    <option key={supplier.supplierName} value={supplier.supplierCode}>
                      {supplier.supplierCode}-{supplier.supplierName}
                    </option>
                  ))}
                </FormSelect>
              </Col>

              {(SAUDI || EGYPT) && selectedSupplier && (
                <Col md="3" className="flx-dir-col">
                  <label className="mb-0">Select File Type</label>
                  <FormSelect
                    id="file-type-select"
                    onChange={(evt) =>
                      this.setState({
                        selectedFileType: evt.target.value,
                      })
                    }
                    value={selectedFileType}
                  >
                    <option value={0}>Select</option>
                    {fileTypeList.map((file) => (
                        <option key={file} value={file}>
                          {file}
                        </option>
                      ))}
                  </FormSelect>
                </Col>
              )}

              {selectedSupplier && selectedFileType && (
                <Col md="3" className="flx-dir-col">
                  <label className="mb-0">Select Year</label>
                  <FormSelect
                    id="year-select"
                    onChange={this.handleSelectedYearChange}
                    // onChange={(evt) =>
                    //   this.setState({
                    //     selectedYear: evt.target.value,
                    //   })
                    // }
                    value={selectedYear}
                  >
                    <option value={0}>Select</option>
                    {yearList.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </FormSelect>
                </Col>
              )}

              {selectedSupplier && selectedFileType && selectedYear && (
                <Col md="3" className="flx-dir-col">
                  <label className="mb-0">Select Month</label>
                  <FormSelect
                    id="month-select"
                    onChange={this.handleSelectedMonthChange}
                    // onChange={(evt) =>
                    //   this.setState({
                    //     selectedMonth: evt.target.value,
                    //   })
                    // }
                    value={selectedMonth}
                  >
                    <option value={0}>Select</option>
                    {monthList.map((mnth) => (
                      <option key={mnth} value={mnth}>
                        {mnth}
                      </option>
                    ))}
                  </FormSelect>
                </Col>
              )}
            </Row>
          </Col>
        </Row>

        {selectedSupplier && selectedFileType && selectedYear && selectedMonth && (
          <Row className="mb-4">
            <Col md="12" className="mb-0" >
              <Form>
                <Row form>
                  <Col className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="">Upload Raw File</label>
                      </Col>
                      <Col className="form-field" md="4">
                        <div className="file-ctrl-wrap">
                          <input 
                              type="file" 
                              className="file-input" 
                              id="file" 
                              name="file"
                              placeholder="Upload your excel file"
                              multiple={(SPAIN || SAUDI || EGYPT) && this.state.supplier.supplierMergeMultipleFiles}
                              onChange={this.readFile.bind(this)}
                            />
                        </div>
                      </Col>
                      <Col className="form-button" md="4">
                        {this.state.file && (
                          <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleFileUpload}>
                            <FcPlus /> Upload Raw File
                          </Button>
                        
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        )}
        
        {batchLogs && (
          <FileUploadErrorLogs batchCode="" processLogs={batchLogs} />
        )}
      </>
    );
  }
}

export default FileUpload;
